import * as moment from 'moment';

import { Ship } from './ship';

import { Effort } from './effort';

import { FilterHandler } from '../shared/filter-handler';

export class EffortItem extends Effort {
  id: number;
  year: string;
  ship: Ship = new Ship();
  amount_deep: number;
  amount_shore: number;
  consumed_shore: number;
  consumed_deep: number;
  pending_shore: number;
  pending_deep: number;

  multiple: boolean;
  selectLabel: string;
  label: string;
  stockLabel: string;

  gesteffort_shore_consumed: Number;
  gesteffort_deep_consumed: Number;
  gesteffort_shore_date: Date;
  gesteffort_deep_date: Date;

  public apiMap(values: Object = {}) {
    const effort_item = new EffortItem(values);

    if (values['ship']) {
      effort_item.ship = new Ship(values['ship']);
    }
    effort_item.consumed_shore = 0;
    effort_item.consumed_deep = 0;
    effort_item.pending_shore = effort_item.amount_shore;
    effort_item.pending_deep = effort_item.amount_deep;
    return effort_item;
  }

  public serialize() {
    const record = super.serialize();
    record['ship'] = this.ship.id;

    return record;
  }
}

export class EffortFilter extends FilterHandler {
  ships: Ship[] = [];
  year: string;

  constructor(values: Object = {}) {
    super();

    this.ships = [];
    this.year = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/effort-item.ts